import { render, staticRenderFns } from "./MainCategories.vue?vue&type=template&id=1632350c"
import script from "./MainCategories.vue?vue&type=script&lang=js"
export * from "./MainCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports